var options = (option_array) => {
  var settings = {
    dom         : 'lrtip',
    responsive  : true,
    autowidth   : true,
    processing  : true,
    serverSide  : true,
    initComplete: function () {
      this.api().columns().every(function () {
        var column = this;
        var search_field = $(column.footer()).find('span:first');
        var input = document.createElement("input");
        input.className = "form-control";
        input.setAttribute('size', 1);
        input.setAttribute('type', "search");
        input.setAttribute('placeholder', search_field.data('placeholder') ?? "Search");
        switch (search_field.data('type')) {
          case "input":
            $(input).appendTo($(column.footer()).empty()).on('change', function () {
              column.search($(this).val(), false, false, true).draw();
            });
            break;
          case "time_picker":
            $(`<input type="search" class="form-control time_picker" autocomplete="off" placeholder="${search_field.data('placeholder') ?? "Search"}"/>`)
            .appendTo($(column.footer()).empty())
            .on('change', function () {column.search($(this).val(), false, false, true).draw();});
            break;
          case "select2":
            var option_list = search_field.data('list');
            var elem = $('<select class="DTselect2">');
            elem.append(`<option></option>`);
            $.each(option_list, function (i, e) {
              elem.append(`<option value="${e}">${e}</option>`);
            });
            elem.appendTo($(column.footer()).empty()).select2({
              placeholder  : search_field.data('placeholder') ?? "Search",
              allowClear   : true,
              closeOnSelect: true
            }).on('change.select2', function (e) {
              column.search($(e.currentTarget).val(), false, false, true).draw();
            });
            break;
          case "select2ajax":
            var option_list = search_field.data('list');
            var elem = $(`<select class="DTselect2" data-ajax--url="${
              search_field.data('url')
            }">`);
            elem.appendTo($(column.footer()).empty()).select2({
              ajax: {
                dataType: 'json',
                processResults: function processResults(data) {
                  return {
                    results: data.data,
                    pagination: {
                      more: data.current_page * data.per_page < data.total
                    }
                  };
                }
              },
              createTag: function createTag(params) {
                var term = $.trim(params.term);
                return term === '' ? null : {
                  id: term,
                  text: "".concat(term, " (\u65B0\u589E)")
                };
              },
              placeholder: search_field.data('placeholder') ?? "Search",
              allowClear: true,
              closeOnSelect: true
            }).on('change.select2', function (e) {
              if ($(e.currentTarget).val() && $(e.currentTarget).val() != null) {
                console.log($(e.currentTarget).val());
                column.search($(e.currentTarget).val(), false, false, true).draw();
              } else {
                column.search("", false, false, true).draw();
              }
            });
            break;
          default:
            break;
        }
      });
      if ($('.time_picker').length) {
        $('.time_picker').daterangepicker({
          locale: {
            "format"          : "DD/MM/YYYY",
            "separator"       : " - ",
            "applyLabel"      : "Select date range",
            "cancelLabel"     : "Cancel",
            "fromLabel"       : "From",
            "toLabel"         : "To",
            "customRangeLabel": "Custom",
            "weekLabel"       : "W",
            "firstDay"        : 1
          },
          autoUpdateInput: false,
          autoApply: true,
          timePicker: false,
          applyButtonClasses: 'btn-primary text-white',
          cancelButtonClasses: 'btn-danger',
          opens: "center",
          drops: "up",
          ranges: {
            'Today': [
              moment(), moment()
            ],
            'Last 7 Days': [
              moment().subtract(6, 'days'),
              moment()
            ],
            'This Month': [
              moment().startOf('month'), moment()
            ],
            'This Year': [
              moment().subtract(1, 'year'),
              moment()
            ]
          }
        }).on('apply.daterangepicker', function (ev, picker) {
          $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm:ss') + "/" + picker.endDate.format('YYYY-MM-DD HH:mm:ss')).trigger('change')
        }).val("").attr('readonly','readonly').trigger('change');
      }
      $(this).find('tfoot.d-none').removeClass('d-none');
    }
  }
  $.each(option_array, function (i, e) {
    settings[i] = e;
  });
  return settings;
}

const remove_item = (url, confirm_msg = "Remove item from table?", msg = null) => {
  if (confirm(confirm_msg)) {
    $.ajax({
      type: "POST",
      url: url,
      data: {
        _method: 'DELETE'
      }
    }).done(function (data) {
      table.ajax.reload();
      toastr.success(msg ?? data.msg);
    })
  }
};

module.exports = {
  options,
  remove_item
}
